/* eslint-disable @typescript-eslint/no-explicit-any */
import { LocalStorageKey } from "@/constants/constants";

import { getLocalStorageItem, setLocalStorageItem } from "../localStorage";
import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface FacebookConfig extends SDKConfig {
  pixelId?: string;
}

declare global {
  interface Window {
    fbq?: {
      (
        command: string,
        pixelId: string,
        eventName?: string,
        parameters?: Record<string, unknown>,
      ): any;
    };
    FB?: {
      init: (config: {
        appId: string;
        cookie: boolean;
        xfbml: boolean;
        version: string;
      }) => void;
    };
  }
}

export class FacebookSDK extends BaseSDK {
  private pixelId: string;
  constructor(config: FacebookConfig) {
    super(SDKName.FacebookSDK, config);
    this.pixelId = config.pixelId || "";
  }

  async initialize(): Promise<void> {
    if (this.pixelId) {
      this.initializePixel(this.pixelId);
    }
  }

  private initializePixel(pixelId: string): void {
    const fbInitData: Record<string, string> = getLocalStorageItem(
      LocalStorageKey.FacebookInit,
      {},
    );
    if (window.fbq || !pixelId) {
      fbInitData.dup = "1";
      setLocalStorageItem(LocalStorageKey.FacebookInit, fbInitData);
      return;
    }
    const script = document.createElement("script");
    script.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    fbInitData.initsuc = "1";
    setLocalStorageItem(LocalStorageKey.FacebookInit, fbInitData);
  }

  // 跟踪自定义事件
  trackEvent(eventName: string, parameters?: Record<string, unknown>): void {
    if (window.fbq) {
      window.fbq("trackSingle", this.pixelId, eventName, parameters);
    }
  }

  // 跟踪转化
  trackConversion(value?: number, currency?: string): void {
    if (window.fbq) {
      window.fbq("trackSingle", this.pixelId, "Purchase", {
        value: value,
        currency: currency || "USD",
      });
    }
  }

  getFacebookEventName(gaEvent: string) {
    let funcName = "trackSingle";
    let fbEvent = "";

    if (!fbEvent) {
      switch (gaEvent) {
        case "register":
          fbEvent = "CompleteRegistration";
          break;
        case "purchase":
          fbEvent = "Purchase";
          break;
      }
    }
    if (!fbEvent) {
      fbEvent = gaEvent;
    } else {
      funcName = "track";
    }
    return { funcName, fbEvent };
  }

  reportEvent(event: string, data: Record<string, unknown>) {
    let result = false;
    if (window.fbq) {
      try {
        const { funcName, fbEvent } = this.getFacebookEventName(event);
        window.fbq(funcName, this.pixelId, fbEvent, data);
        result = true;
      } catch (error) {
        console.error("FacebookSDK reportEvent error", error);
      } finally {
        result = true;
      }
    }
    return result;
  }
}
